import appConfigCoverGoProd from "./appConfigCoverGoProd.js"
import { COVERGO_SAAS_PROD } from "../consts.js"

export const vertex = {
	"vertex-uat-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_SAAS_PROD }
}
